import { swalErrorMessage } from "../../../../Constant/swalMessage";
import {
  getServerDetailsService,
  pauseGatewayService,
  pauseServerService,
  setPooledAiGatewayService,
} from "../../services/gatewayConfig.services";

export const pauseGatewayAction = (gatewayName, obj) => async () => {
  const res = await pauseGatewayService(gatewayName, obj);
 return res;
};

export const setPooledAiGatewayAction = (gatewayName, obj) => async () => {
  const res = await setPooledAiGatewayService(gatewayName, obj);
  return res;
};

export const pauseServerAction = (obj) => async () => {
  const res = await pauseServerService(obj);
  if (res) {
    return res;
  } else {
    swalErrorMessage(res?.errMsg);
  }
};
export const getServerDetailsAction = (params) => async () => {
  const res = await getServerDetailsService(params);  

  if (res) {
    return res?.data;
  } else {
    swalErrorMessage(res?.errMsg);
  }
};
